module.exports = "/_next/static/images/video-cd83a4699accf4748358217d72cb50a0.png";